module.exports = __webpack_public_path__ + "img/mastercard.767c5519.png";